<template>
<div>
    <footer class="main-footer" v-if="exibefooter">
        <div class="center">
            <div class="site-map">
                <a href="https://apaixonadossaudepet.com.br/pagina-inicial/"><img src="../Content/images/logo.png" width="150px" class="logo-footer"></a>
                <div class="menu-footer">
                    <br>
                    <div class="row" style="margin-top: 10px;">
                        <div class="row">
                            

                            <a href='https://apaixonadossaudepet.com.br/contato/' >Contato &nbsp;&nbsp;&nbsp;&nbsp;</a>
                            <router-link to="/areacliente" >Área do Pet &nbsp;&nbsp;&nbsp;&nbsp;</router-link>
            
                            <a v-if="userloggedin" @click="Sair"><i class="fas fa-angle-right"></i> Sair</a>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    </footer>
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-actions class="grey darken-2 justify-end">
        <p  style="color:#f3f1f1;font-size: 12px;">Desenvolvido por &nbsp;</p>
        <a href="http://www.intelitetecnologia.com.br/" target="_blank" style="margin-bottom: -8px;"><img src="../Content/images/intelite.png" alt="" width="100px" ></a>
      </v-card-actions>
    </v-card>
    <Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
import Snackbar from '../components/snackbar.vue'
import { mapState } from 'vuex'
export default {
    components: {Snackbar},
    data(){
        return{

        }
    },
    computed: {
       ...mapState({
        userloggedin: state => state.userloggedin,
        exibefooter: state => state.isFooterVisible
    })
    },
/*     mounted : function(){
      this.$store.dispatch('Logar')
    }, */
    methods: {
    Sair(){
            this.$store.dispatch('Sair')
            this.$router.push({ path: '/areacliente' })
        },
    exibeMsgConstrucao(){
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1","Disponível em breve!","INFORMAÇÃO")
        }
    }
}
</script>

<style>

</style>
